module.exports = __webpack_public_path__ + "img/dgitem4.e42dcb52.png";